package com.evoapps.evoshift.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
actual fun rememberPermissionState(permission: AppPermission): PermissionState {
    return remember {
        object : PermissionState {
            override val isGranted: Boolean = true
            override fun launchPermissionRequest() {
                // Web permissions are usually handled by the browser automatically
                // or via specific Web APIs when needed.
            }
        }
    }
}
